module.exports = __webpack_public_path__ + "static/media/error-server.076bfae7.svg";